<template>
    <div v-if="$store.state.policy.activityCode !== 'ESUN'">
        <div class="footer__info">
            <ul class="footer__ul">
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Home"
                        href="https://www.tmnewa.com.tw/"
                        target="_blank"
                    >
                        官網首頁
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_claimSettlement"
                        href="https://www.tmnewa.com.tw/customerservice/claimsettlement"
                        target="_blank"
                    >
                        理賠服務
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Location"
                        href="https://www.tmnewa.com.tw/location"
                        target="_blank"
                    >
                        服務據點
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Products"
                        href="https://www.tmnewa.com.tw/customerservice/documentdownload/productterms"
                        target="_blank"
                    >
                        商品條款
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Statement"
                        href="https://www.tmnewa.com.tw/customerprotectionstatement"
                        target="_blank"
                    >
                        聲明事項
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Fsc"
                        href="https://www.fsc.gov.tw/ch/index.jsp"
                        target="_blank"
                    >
                        金融監督管理委員會
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Consumer"
                        href="https://cpc.ey.gov.tw/"
                        target="_blank"
                    >
                        消費者保護
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Specification"
                        href="https://law.lia-roc.org.tw/Law/Content?lsid=FL034012"
                        target="_blank"
                    >
                        保險業經營電子商務自律規範
                    </a>
                </li>
                <li class="footer__list">
                    <a
                        data-accuid="Footer_Specification"
                        href="https://www.tmnewa.com.tw/insurance-fraud-prevention/"
                        target="_blank"
                    >
                        防詐杜絕風險專區
                    </a>
                </li>
            </ul>

            <!-- 1280px以上的電話服務區塊 -->
            <div class="footer__phone--lg">
                <div class="phone__li phone__li--first">
                    24小時客服、道路救援專線：{{ service }}
                </div>
                <div class="phone__li phone__li--second">
                    網路服務專線：{{ tel }} ( {{ serviceTime }} )
                </div>
                <div class="phone__li phone__li--third">
                    地址：{{ address }}
                </div>
                <div class="phone__li">
                    建議瀏覽器：Chrome109、Safari16、Edge109以上版本
                </div>
            </div>
            <!--/ 1280px以上的電話服務區塊 -->

            <div class="footer__phone--md">
                24小時客服、道路救援專線：{{ service }}｜網路服務專線：{{ tel }} ( {{ serviceTime }} ) ｜地址：{{ address }}｜建議瀏覽器：Chrome10、Safari16、Edge109以上版本
            </div>

            <!-- 1280px以下的電話服務區塊 -->
            <div class="footer__phone--sm">
                24小時客服、道路救援專線：{{ service }}<br>
                網路服務專線：{{ tel }} <br> 
                ( {{ serviceTime }} ) <br>
                地址：{{ address }}<br>
                建議瀏覽器：Chrome10、Safari16、Edge109以上版本
            </div>
            <!--/ 1280px以下的電話服務區塊 -->
            <div class="flex flex-wrap text-white item-start mx-3 xl:justify-center pb-2 xl:pb-0">
                <span>
                    新安東京海上遵循「保險業金融友善服務準則」之精神，建立友善的金融服務環境，提供多國語言貼心服務。
                    <a
                        class="underline"
                        target="_blank"
                        href="https://easyaccess.tmnewa.com.tw/friendly.html"
                    >
                        點此了解更多內容
                    </a>
                </span>
            </div>
            <div class="flex text-white item-start mx-3 px-0.5 xl:justify-center">
                <!-- gap-2.5 mx-3 px-0.5 py-2 xl:px-2 -->
                流程代碼：{{ clarityId }}
            </div>
        </div>
        
        <div class="footer__bar">
            <div class="bar__tokio">
                <img
                    src="@/assets/images/tokio-marine-group.svg"
                    alt="Tokio Marine Group"
                    loading="lazy"
                    class="bar__tokioImg"
                >
            </div>
            <div class="bar__company">
                <div class="bar__info">
                    <a
                        data-accuid="Footer_TMH"
                        href="https://www.tokiomarinehd.com/en/company/information/ci.html"
                        target="_blank"
                    >
                        <img
                            src="@/assets/images/Group.png"
                            alt="to be a good company"
                            loading="lazy"
                            class="bar__group"
                        >
                    </a>
                    <p class="bar__copyright">
                        Copyright ©2023 新安東京海上產物保險股份有限公司 All rights reserved
                    </p>
                </div>
                <img
                    src="@/assets/images/wave.png"
                    alt="新安東京海上產險"
                    loading="lazy"
                    class="bar__companyImg"
                >
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Footer
 */
export default {
    name: 'CustomFooter',
    data() {
        /**
         * @param {String} serviceTime 營業時間
         * @param {String} tel 網路服務專線
         * @param {String} address 地址
         * @param {String} service 客服專線
         */
        return {
            serviceTime:process.env.VUE_APP_FOOTER_SERVICE_TIME,
            tel:process.env.VUE_APP_TEL,
            address: process.env.VUE_APP_ADDRESS,
            service: process.env.VUE_APP_SERVICE_TEL,
            clarityId: this.$store.state.estimate.ClarityId
        };
    },
    watch: {
        '$store.state.estimate.ClarityId': {
            handler(value) {
                if (value) {
                    this.clarityId = this.$store.state.estimate.ClarityId;
                } else {
                    this.clarityId = '';
                }
            }
        }
    }
};
</script>

<style scoped lang="scss">
.footer__info {
    background-color: $blue-700;
    padding-top: 0.5rem;
    padding-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    font-size: .875rem;
    color: white;
}

.footer__ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    @include xl {
        flex-wrap: nowrap;
        justify-content: center;
    }
}

.footer__list {
    width: 100%;
    padding: 0.5rem 0.125rem 0.5rem 0.125rem;
    border-color: white;
    border-bottom-width: 0.5px;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    @include xl {
        width: auto;
        padding: 0rem 0.5rem 0rem 0.5rem; // 上右下左
        border-bottom-width: 0;
        border-right-width: 1px;
        margin-left: 0;
        margin-right: 0;
    }
}

.footer__list:last-child {
    @include xl {
        border-right-width: 0;

    }
}

.footer__phone--lg{
    display: none;
    @include xl {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .phone__li {
        border-color: white;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        @include xl {
            white-space: nowrap;
        }
    }
    .phone__li--first {
        border-right-width: 0.5px;
    }
    .phone__li--second {
        border-right-width: 0.5px;
    }
    .phone__li--third {
        border-right-width: 0.5px;
        @include xl {
            border-right-width: 0;
        }
        @include xxl {
            border-right-width: 0.5px;
        }
    }
}



.footer__phone--md{
    display: none;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    padding: 0.5rem 0.125rem;
    @include sm {
        display: block;
    }
    @include xl {
        display: none;
    }
}

.footer__phone--sm{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    padding: 0.5rem 0.125rem;
    @include sm {
        display: none;
    }
}

.footer__bar {
    height: 5rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: white;
    background: linear-gradient(90deg,#00b3fe,#039);
    border-color: white;
    border-top-width: 1px;
    @include lg {
        height: 6rem;
    }
}

.bar__tokio {
    display: flex;
    padding-top: 20px;
    @include sm {
        padding-top: 0;
        align-items: center;
    }
}

.bar__tokioImg {
    height: 1rem;
    margin: 0.25rem 0.5rem;
    position: absolute;
    @include sm {
        display: block;
    }
    @include xl {
        height: 1.25rem;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
    }
}

.bar__company {
    display: flex;
    flex-wrap: nowrap;
    margin-right: 0.25rem;
    padding-top: 10px;
    @include sm {
        margin-right: 0;
    }
}

.bar__info {
    margin-left: 0px;
    margin-right: 0px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    @include sm {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }
}

.bar__group {
    height: 1rem;
    @include sm {
        height: 1.25rem;
    }
    @include xl {
        height: 1.5rem;
    }
}

.bar__copyright {
    width: 100%;
    text-align: right;
    font-size: 8.5px;
    white-space: nowrap;
    @include xl {
        font-size: .75rem;
    }
}

.bar__companyImg {
    right: 0px;
    height: 0.75rem;
    position: absolute;
    align-self: flex-end;
    @include sm {
        position: relative;
    }
    @include lg {
        height: 1.5rem;
    }
}
</style>
